module.exports = __webpack_public_path__ + "img/frozen1.e3e0dabc.png";